// extracted by mini-css-extract-plugin
export var li = "_v5-2";
export var ol = "_v5-1";
export var ul = "_v5-0";